import React from "react"

import * as styles from "./index.module.scss"

type Props = {
  color?: string
  className?: string
}

function HorizontalDivider({ color, className }: Props) {
  return (
    <div
      style={{ background: color }}
      className={`${styles.divider} ${className}`}
    />
  )
}

export default HorizontalDivider
